import qFetch from '@/utils/qFetch'

export function receiveExMemberForQ(scene = '') {
  const url = '/bnbapp-node-cq/app/user/receiveexmember/bnb'
  const ajaxData = {
    parameter: { scene }
  }

  return qFetch({
    url: '/tjbnb/app/common/nologin',
    data: ajaxData,
    extraParam: {
      u: url
    },
    extraCParams: {
      newPlatform: true
    }
  }).then((res) => {
    return Promise.resolve(res)
  })
}
